module.exports = __webpack_public_path__ + "img/categories_green.506d69a1.svg";